import StockInputService from '@/services/retailer/StockInputService.js'
import { build_query } from '@/utilities/helpers.js'

export const namespaced = true

export const allowedFilters = ['product_id', 'brand_id', 'unit_id']

const allowedIncludes = 'products, brands, units'
const allowedAppends = 'total_reserved_quantity'

export const state = {
  stocks: [],
  meta: {},
  links: {}
}

export const mutations = {
  SET_STOCKS(state, stockInputs) {
    state.stocks = stockInputs.data
    state.meta = stockInputs.meta
    state.links = stockInputs.links
  }
}

export const actions = {
  getStocks({ commit, state }, query) {
    let newQuery = build_query(query, allowedFilters, allowedIncludes)

    return new Promise(resolve => {
      StockInputService.getStocks(newQuery).then(response => {
        commit('SET_STOCKS', response)
        resolve(response)
      })
    })
  }
}
